import { Module } from "../../types/Module";

export function buildMenuTree(modules: Module[]): Module[] {
  const moduleMap: Record<number, Module & { children?: Module[] }> = {};
  const roots: Module[] = [];

  modules.forEach((mod) => {
    moduleMap[mod.module_id] = { ...mod, children: [] };
  });

  modules.forEach((mod) => {
    if (mod.module_parent === 0) {
      roots.push(moduleMap[mod.module_id]);
    } else {
      const parent = moduleMap[mod.module_parent];
      if (parent) {
        parent.children!.push(moduleMap[mod.module_id]);
      }
    }
  });

  // const sortModules = (mods: Module[]): Module[] =>
  //   mods
  //     .sort((a, b) => a.module_order - b.module_order)
  //     .map((m) => ({
  //       ...m,
  //       children: m.children ? sortModules(m.children) : [],
  //     }));

  // Sort function that pushes 'Settings' and 'Logout' to the bottom
  const sortModules = (mods: Module[]): Module[] =>
    mods
      .sort((a, b) => {
        const bottomModules = ["Logout"]; // ✅ Only Logout in bottom
        const aIsBottom = bottomModules.includes(a.module_name);
        const bIsBottom = bottomModules.includes(b.module_name);

        if (aIsBottom && !bIsBottom) return 1;
        if (!aIsBottom && bIsBottom) return -1;
        return a.module_order - b.module_order;
      })
      .map((m) => ({
        ...m,
        children: m.children ? sortModules(m.children) : [],
      }));


  return sortModules(roots);
}
